






























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component({

})

export default class OutputRecordList extends Vue {
    @Prop() data!: {};

    isPay(output: any) {
        return output.selectedTag === '支出';
    }

    isEarning(output: any) {
        return output.selectedTag === '收入';
    }
}
